import { Component, EventEmitter, Input, Output } from '@angular/core';
import { buildButtonClasses } from '../button/button-classes.util';
import type { IconButtonDensity } from '../icons/action-icon';

@Component({
  selector: 'app-confirm-icon-button',
  template: `
    <button
      type="button"
      [disabled]="disabled || loading"
      [attr.aria-label]="ariaLabel"
      [attr.title]="title || ariaLabel"
      [attr.aria-pressed]="active"
      [class]="buttonClasses"
      (click)="onClick.emit($event)"
    >
      <app-spinner *ngIf="loading" size="sm"></app-spinner>
      <app-action-icon *ngIf="!loading" name="confirm" [density]="density"></app-action-icon>
    </button>
  `,
  styleUrls: ['../icons/icon-button.scss'],
  host: {
    class: 'tt-icon-btn-host',
    '[class.tt-icon-btn-host--toolbar]': 'density === "toolbar"',
    '[class.tt-icon-btn-host--row]': 'density === "row"',
  },
})
export class ConfirmIconButtonComponent {
  @Input() ariaLabel = 'Schválit';
  @Input() title = '';
  @Input() disabled = false;
  @Input() loading = false;
  /** True when the row is already schváleno (toggle off). */
  @Input() active = false;
  /** Empty follows context: 40px in the page header, 32px elsewhere. */
  @Input() density: IconButtonDensity = '';
  @Output() onClick = new EventEmitter<MouseEvent>();

  get buttonClasses(): string {
    return `${buildButtonClasses({
      variant: this.active ? 'success' : 'secondary',
      size: 'sm',
      iconOnly: true,
    })} shrink-0`;
  }
}
